export function initSentry() {
  if (typeof window === "undefined" || !import.meta.env.VITE_SENTRY_DSN) return;
  try {
    import('@sentry/react').then(Sentry => {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENV || 'production',
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
      });
    }).catch(() => {});
  } catch {
    // never block app
  }
}

export function trackInfo(message: string, data?: Record<string, unknown>) {
  if (import.meta.env.DEV) console.info("[trackInfo]", message, data || {});
}

export function trackError(error: unknown, data?: Record<string, unknown>) {
  if (import.meta.env.DEV) console.error("[trackError]", error, data || {});
}
